import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import Company from "./Company";
import Staff from "./Staff";
import PageHeader from "../../../../components/PageHeader/PageHeader";

class Schedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: "company",
      addScheduleHandler: null,
    };
  }

  registerAddHandler = (fn) => {
    this.setState({ addScheduleHandler: fn });
  };

  render() {
    const { page } = this.state;

    return (
      <div className="create-event-wrapper">
        <div className="create-event-container">
          <Row>
            <Col md="12">
              <PageHeader
                title="Availability"
                subtitle="Set the hours when you're available for bookings."
              />
              <div className="sch-page-header">
                <div className="sch-header-actions">
                  <div className="filter_bar dark">
                    <ul className="cus_tab">
                      <li>
                        <button
                          className={`btn ${page === "company" ? "active" : ""}`}
                          onClick={() => {
                            if (page !== "company") {
                              this.setState({ page: "company", addScheduleHandler: null });
                            }
                          }}
                        >
                          Business Hours
                        </button>
                      </li>
                      <li>
                        <button
                          className={`btn ${page === "staff" ? "active" : ""}`}
                          onClick={() => {
                            if (page !== "staff") {
                              this.setState({ page: "staff", addScheduleHandler: null });
                            }
                          }}
                        >
                          Staff Availability
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Col>

            {page === "company" ? (
              <Company onRegisterAddHandler={this.registerAddHandler} />
            ) : (
              <Staff onRegisterAddHandler={this.registerAddHandler} />
            )}
          </Row>
        </div>
      </div>
    );
  }
}

export default Schedule;
